<template>
<div class="ranking-index">
  <div class="row">
    <div class="col-lg-8 col-xs-12">
      <event-card
        v-loading="eventLoading"
        :event="event"
      />
    </div>

    <div class="col-lg-4 col-xs-12">
      <div class="ranking-actions card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-6"><h4 class="card-title"><i class="ti-list"></i> Ações </h4></div>
          </div>
        </div>
        <div class="card-content">
          <div
            class="row"
            style="margin-bottom: 10px;"
          >
            <div class="col-xs-12">
              <ranking-actions
                :tickets="tickets"
                :event="event"
                v-loading="ticketsLoading || surveysLoading || eventLoading"
                @runMakeRanking="fetch()"
              ></ranking-actions>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="row"
    v-if="event.drawn"
  >
    <div class="col-xs-12">
      <ranking-list
        :tickets="tickets"
        :event="event"
        :surveys="surveys"
        v-loading="ticketsLoading || surveysLoading"
      ></ranking-list>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import RankingList from 'src/pages/Ranking/RankingList'
import RankingActions from 'src/pages/Ranking/RankingActions'
import EventCard from 'src/pages/Events/EventCard'

export default {
  name: 'ranking-index',

  components: {
    RankingList,
    RankingActions,
    EventCard
  },

  computed: {
    ...mapGetters('events', {
      event: 'event',
      eventLoading: 'loading'
    }),
    ...mapGetters('surveys', {
      surveysLoading: 'loading'
    }),
    ...mapGetters('tickets', {
      ticketsLoading: 'loading'
    }),
    eventId () {
      return this.$route.params.id
    },

    tickets: {
      get () {
        return this.$store.state.tickets.all.filter(ticket => {
          return this.surveys.find(survey => {
            return survey.ticketId === ticket._id
          })
        }).sort((a, b) => {
          return a.rankingNow && b.rankingNow ? a.rankingNow - b.rankingNow : 0
        }).map(ticket => {
          ticket.survey = this.surveys.find(survey => {
            return survey.ticketId === ticket._id
          })
          return ticket
        })
      }
    },

    surveys: {
      get () {
        return this.$store.state.surveys.all.filter(survey => {
          return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && (survey.data.accepted && survey.data.accepted !== 'false')
        })
      }
    }
  },

  methods: {
    ...mapActions('events', {
      fetchEvent: 'fetchOne',
      resetEvent: 'resetOne'
    }),

    ...mapActions('tickets', {
      fetchTicketsWithCustomersByEvent: 'fetchTicketsWithCustomersByEvent',
      resetTickets: 'resetAll'
    }),

    ...mapActions('surveys', {
      associateSurveys: 'associateSurveys',
      fetchSurveys: 'fetchViewAll',
      resetSurveys: 'resetAll'
    }),

    reset () {
      this.resetEvent()
      this.resetTickets()
      this.resetSurveys()
    },

    fetch () {
      this.fetchEvent(this.eventId)

      this.fetchTicketsWithCustomersByEvent({
        where: {
          eligible: true,
          surveyAssociated: true
        },
        eventId: this.eventId
      })

      this.fetchSurveys({
        database: 'surveys',
        ddoc: 'surveys-by-event',
        view: 'surveys-by-event',
        key: this.eventId
      })
    }
  },

  mounted () {
    this.reset()
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Ranking/RankingIndex.vue